<template>
  <footer class="partner_11">
    <h3>合作伙伴</h3>
    <div bg-url="@/plan/assets/image/11/partner.png" v-bg class="partner_list_11"></div>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.partner_11 {
  height: 650px;
  background-color: #F7F8FA;

  h3 {
    padding: 100px 0 50px 0;
    font-weight: 700;
    font-size: 56px;
    line-height: 79px;
    text-align: center;
    color: #000000;
  }
}

.partner_list_11 {
  margin: 0 auto;
  width: 924px;
  height: 155px;
  background-size: 100%;
}
</style>
